var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmojiIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2001 8.22275V2.22275H38.2001V8.22275H32.2001V11.2227H38.2001V17.2227H41.2001V11.2227H47.2001V8.22275H41.2001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9501 24.7227H11.2001V28.4727H14.9501V24.7227Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7001 24.7227H23.9501V28.4727H27.7001V24.7227Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7725 36.7227H19.1279C17.9319 36.7266 16.7623 36.3712 15.7707 35.7026C14.779 35.034 14.011 34.0829 13.5661 32.9727H10.3345L10.7716 34.0652C11.4347 35.7387 12.5866 37.1736 14.0772 38.1828C15.5678 39.192 17.3279 39.7286 19.1279 39.7227H19.7725C21.5725 39.7286 23.3326 39.192 24.8231 38.1828C26.3137 37.1736 27.4656 35.7387 28.1287 34.0652L28.5657 32.9727H25.3342C24.8893 34.0829 24.1213 35.0339 23.1297 35.7025C22.138 36.3712 20.9684 36.7266 19.7725 36.7227V36.7227Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4501 12.7227C9.93845 12.7227 2.20014 20.4611 2.20014 29.9727C2.20014 39.4844 9.93845 47.2227 19.4501 47.2227C28.9618 47.2227 36.7001 39.4844 36.7001 29.9727C36.7001 20.4611 28.9618 12.7227 19.4501 12.7227ZM19.4501 44.2227C11.5927 44.2227 5.20014 37.8302 5.20014 29.9727C5.20014 22.1153 11.5927 15.7227 19.4501 15.7227C27.3076 15.7227 33.7001 22.1153 33.7001 29.9727C33.7001 37.8302 27.3076 44.2227 19.4501 44.2227Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiIcons);
export default __webpack_public_path__ + "static/media/emojiIcons.3aa84e14.svg";
export { ForwardRef as ReactComponent };